
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pam/ad-bridging",
      function () {
        return require("private-next-pages/pam/ad-bridging.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pam/ad-bridging"])
      });
    }
  